import Axios from "../utils/axiosInstance";
import fileSaver from "file-saver";

export const getWorkOrderNoDropDown = (status, headers) => {
  return Axios.get(`/production/getWorkOrderNoDropDown?status=${status}`, {
    headers,
  });
};

export const getWorkOrderByDispenserSrNo = (dispenserSrNo, jobType) => {
  let token = sessionStorage.getItem("token");
  let role = sessionStorage.getItem("role");
  let fkUserId = sessionStorage.getItem("pkUserId");
  return Axios.get(
    `/workorder/getDispenserNowiseWorkOrderDetails?dispenserSrNo=${dispenserSrNo}&jobType=${jobType}&fkUserId=${fkUserId}&role=${role}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
};

export const getDispatchListByDispenserSrNo = (dispenserSrNo) => {
  let token = sessionStorage.getItem("token");
  let role = sessionStorage.getItem("role");
  let fkUserId = sessionStorage.getItem("pkUserId");
  return Axios.get(
    `/dispatch/getDispatchDispenserListByDispenserSrNo?dispenserSrNo=${dispenserSrNo}&fkUserId=${fkUserId}&role=${role}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
};

export const getAllWoDispenserList = (
  pageNo,
  jobType,
  fkUserId,
  role,
  headers,
  status
) => {
  //let jobType = ["calibration"];
  return Axios.get(
    `/workorder/getWorkOrderStatusWiseListForServiceEngineer/${pageNo}?jobType=${jobType}&fkUserId=${fkUserId}&role=${role}&status=${status}`,
    {
      headers,
    }
  );
};

export const getDispenserSrNoDropDList = (status, headers) => {
  return Axios.get(`/workorder/getDispenserSrNodDropDownList?status=${status}`, {
    headers,
  });
};
